import React, { useState } from "react";

import * as Dropdown from "ds/Dropdown";

import * as S from "./SshHostList.styles";

export interface SshHostListProps {
  sshList: { value: string; id: string }[];
}

const SshHostList = ({ sshList }: SshHostListProps) => {
  const [selected, setSelected] = useState(() => sshList?.[0] || {});

  return (
    <S.Layout>
      <Dropdown.Root>
        <Dropdown.Trigger variant="picklist">
          {selected.id}
          <Dropdown.Chevron />
        </Dropdown.Trigger>
        <Dropdown.Portal>
          <S.DropdownContent>
            {sshList.map(ssh => (
              <Dropdown.Item
                key={ssh.value}
                onClick={() => {
                  setSelected(ssh);
                }}
                analyticId="ssh-host-selector"
                $isSelected={ssh?.id === selected?.id}
              >
                {ssh.id}
              </Dropdown.Item>
            ))}
          </S.DropdownContent>
        </Dropdown.Portal>
      </Dropdown.Root>

      <S.CodeBlock singleLine isCopyable id={selected.value}>
        {selected.value}
      </S.CodeBlock>
    </S.Layout>
  );
};

export default SshHostList;
